/**
 * Shared utility functions for entity display
 */

/**
 * Convert string to title case
 */
export const toTitleCase = (str: string): string =>
  str
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

/**
 * Format a date string to localized short format
 */
export const formatDate = (
  dateStr: string | null | undefined,
): string | null => {
  if (!dateStr) return null;
  try {
    return new Date(dateStr).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return dateStr;
  }
};

/**
 * Format enum value (replace underscores with spaces, capitalize)
 */
export const formatEnum = (value: string): string => value.replace(/_/g, ' ');

/**
 * Build full name from name parts
 */
export const buildFullName = (
  firstName?: string | null,
  middleName?: string | null,
  lastName?: string | null,
  suffix?: string | null,
): string =>
  [firstName, middleName, lastName, suffix]
    .filter(Boolean)
    .map((part) => toTitleCase(part || ''))
    .join(' ');
